import { render } from "./AlbumComponent.vue?vue&type=template&id=26a0622e"
import script from "./AlbumComponent.vue?vue&type=script&lang=js"
export * from "./AlbumComponent.vue?vue&type=script&lang=js"

import "./AlbumComponent.vue?vue&type=style&index=0&id=26a0622e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__